import '../types/externs'
import Dicer from './'

module.exports = Dicer